import React from 'react';

const FileInput = ({
  label,
  name,
  id,
  onChange,
  required = false,
  disabled = false,
  className = '',
  currentFileMessage = null,
  error,
}) => {
  const baseClasses = "shadow appearance-none border rounded w-full py-2 px-3 bg-gray-700 text-text-white leading-tight focus:outline-none focus:shadow-outline file:mr-4 file:py-0 file:px-1 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"; // Adjusted padding to px-1
  const errorClasses = error ? "border-red-500" : "border-border-subtle";

  return (
    <div className="mb-4">
      <label className="block text-text-gray text-sm font-bold mb-2" htmlFor={id}>
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type="file"
        name={name}
        id={id}
        onChange={onChange}
        disabled={disabled}
        className={`${baseClasses} ${errorClasses} ${className}`}
      />
      {currentFileMessage && (
        <div className="text-text-gray text-sm mt-2">{currentFileMessage}</div>
      )}
      {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
    </div>
  );
};

export default FileInput;